import React from "react";

export function Emblem({ className = "h-10 w-10" }) {
  return <img src="/chef-plated-emblem.png" alt="Chef Plated" className={className} draggable={false} />;
}

export function LogoFull({ className = "h-12" }) {
  return <img src="/chef-plated-logo.png" alt="Chef Plated" className={className} draggable={false} />;
}

export function WordMark({ compact = false }) {
  return (
    <div className="flex items-center gap-3 select-none">
      <Emblem className={compact ? "h-8 w-8" : "h-10 w-10"} />
      <span className={`font-serif tracking-wide gold-text ${compact ? "text-lg" : "text-2xl"}`}>
        CHEF PLATED
      </span>
    </div>
  );
}
